import React from "react";
import { useFormikContext } from "formik";
import TextField from "@mui/material/TextField";

export default function BillingTypeFormInput({ name, value, label, onClick }) {
  const { errors, submitCount, getFieldMeta } = useFormikContext();
  const meta = getFieldMeta(name);
  const errorMessage = meta.error || errors[name];
  const error = (meta.touched || submitCount > 0) && errorMessage;

  return (
    <TextField
      fullWidth
      error={!!error}
      helperText={error}
      size="small"
      label={label}
      value={value || ""}
      onClick={onClick}
      InputProps={{
        readOnly: true,
      }}
      placeholder="Click to select"
    />
  );
}
